import { Empty } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import Machine from '../../../../../types/api/machine'
import QueueColumn from '../../../flexo/components/machines-queues/components/queue-column/queue-column'
import MachineQueue from './components/machine-queue/machine-queue'
import MachineQueueTitle from './components/machine-queue-title/machine-queue-title'
import MachineWaitingQueue from './components/machine-waiting-queue/machine-waiting-queue'

const ColumnsRow = styled.div`
    display: flex;
    gap: 24px;
    height: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;
`

const EmptyState = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

interface MachinesQueuesProps {
    machines: Machine[]
    isLoading: boolean
}

const MachinesQueues: FC<MachinesQueuesProps> = ({ machines, isLoading }) => {
    if (!isLoading && machines.length === 0) {
        return (
            <EmptyState>
                <Empty description='Станки перемотки не найдены' />
            </EmptyState>
        )
    }

    return (
        <ColumnsRow>
            {[...machines]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(machine => (
                    <QueueColumn
                        key={machine.documentId}
                        title={<MachineQueueTitle machine={machine} />}
                        mainQueue={<MachineQueue machineDocId={machine.documentId} />}
                        waitingQueue={<MachineWaitingQueue machineDocId={machine.documentId} />}
                    />
                ))}
        </ColumnsRow>
    )
}

export default MachinesQueues
